import {ListViewContext as $9710157b2ac3a032$export$870039b0abfe3de0} from "./ListView.mjs";
import $jVFbp$react, {useContext as $jVFbp$useContext, useRef as $jVFbp$useRef} from "react";
import {useVisuallyHidden as $jVFbp$useVisuallyHidden} from "react-aria/VisuallyHidden";




function $d49010fa0b5f14af$export$2e2bcd8739ae039() {
    let { dropState: dropState, dragAndDropHooks: dragAndDropHooks } = (0, $jVFbp$useContext)((0, $9710157b2ac3a032$export$870039b0abfe3de0));
    let ref = (0, $jVFbp$useRef)(null);
    let { dropIndicatorProps: dropIndicatorProps } = dragAndDropHooks.useDropIndicator({
        target: {
            type: 'root'
        }
    }, dropState, ref);
    let isDropTarget = dropState.isDropTarget({
        type: 'root'
    });
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $jVFbp$useVisuallyHidden)();
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return /*#__PURE__*/ (0, $jVFbp$react).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden']
    }, /*#__PURE__*/ (0, $jVFbp$react).createElement("div", {
        role: "gridcell",
        "aria-selected": "false"
    }, /*#__PURE__*/ (0, $jVFbp$react).createElement("div", {
        role: "button",
        ...visuallyHiddenProps,
        ...dropIndicatorProps,
        ref: ref
    })));
}


export {$d49010fa0b5f14af$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=RootDropIndicator.mjs.map
